import { Record } from 'immutable';
import { makeErrorTranslation } from './ErrorTranslation';
export const makeErrorDetails = Record({
  translation: makeErrorTranslation(),
  tid: undefined,
  type: undefined
});